import { render, staticRenderFns } from "./ExternaAdd.vue?vue&type=template&id=a5ccd3f6&scoped=true"
import script from "./ExternaAdd.vue?vue&type=script&lang=js"
export * from "./ExternaAdd.vue?vue&type=script&lang=js"
import style0 from "./ExternaAdd.vue?vue&type=style&index=0&id=a5ccd3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ccd3f6",
  null
  
)

export default component.exports